import { useTranslation } from 'react-i18next';

import StaticPageLayout from '@/Layout/StaticPageLayout';
import CheckMark from '@/assets/icons/check-mark.svg?react';
import PageMeta from '@/shared/components/PageMeta';

import styles from './Success.module.scss';

const PLAYER_CENTER_URL = 'https://account.ryulink.xyz/ryulink/account';

/** RyuLink patch: keep stock copy; open player center in a new tab (no token in URL). */
const Success = () => {
  const { t } = useTranslation();

  const openPlayerCenter = () => {
    // Keep this success page open; player center is an independent tab.
    window.open(PLAYER_CENTER_URL, '_blank');
  };

  return (
    <StaticPageLayout>
      <PageMeta titleKey="description.device_activation_success" />
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <CheckMark className={styles.icon} />
        </div>
        <div className={styles.title}>{t('description.device_activation_success')}</div>
        <div className={styles.description}>
          {t('description.device_activation_success_description')}
        </div>
        <button className={styles.playerCenterLink} type="button" onClick={openPlayerCenter}>
          打开 RyuLink 玩家中心
        </button>
      </div>
    </StaticPageLayout>
  );
};

export default Success;
